import { SkipIcon, NextIcon, PrevIcon, RightUTurn } from "images";

export const IconNames = {
  Skip: SkipIcon,
  Next: NextIcon,
  Previous: PrevIcon,
  RightUTurn: RightUTurn,
};
